import { FormValues } from '../types';

const transformCheckboxBooleans = (userData: FormValues) => {
    return {
        ...userData,
        terms: userData.terms ? '1' : '0',
        privacy: userData.privacy ? '1' : '0',
        agree: userData.agree ? '1' : '0',
    };
};

export default transformCheckboxBooleans;